import { render } from "./ModalOnHold.vue?vue&type=template&id=66e1d106&scoped=true"
import script from "./ModalOnHold.vue?vue&type=script&lang=js"
export * from "./ModalOnHold.vue?vue&type=script&lang=js"

import "./ModalOnHold.vue?vue&type=style&index=0&id=66e1d106&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e1d106"]])

export default __exports__